import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/contacto/page.tsx");
